import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {APP_ROUTES} from "./app.routes";
import {LocationStrategy, PathLocationStrategy} from "@angular/common";

@NgModule({
  imports: [
    RouterModule.forRoot(APP_ROUTES, {
      scrollPositionRestoration: "top",
      anchorScrolling: "enabled",
      initialNavigation: "enabledBlocking",
      onSameUrlNavigation: 'ignore'
    })
  ],
  providers: [
    {provide: LocationStrategy, useClass: PathLocationStrategy}
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
